function newBarCodeInfo(decodedText) {
  return {
    sCode: decodedText,
    iQty: 1,
    type: 'unknown',
    sku: '',
    gtin: '',
    expDate: -1,
    lotNumber: '',
    serialNumber: '',
    manufacturedDate: -1,
    ok: false,
  };
}

export function parseBarCode(decodedText) {
  const barCodeInfo = newBarCodeInfo(decodedText);

  const info1 = parseTypeI(barCodeInfo);
  if (info1.ok) {
    return info1;
  }

  const info2 = parseTypeII(barCodeInfo);
  if (info2.ok) {
    return info2;
  }

  const info3 = parseTypeIII(barCodeInfo);
  if (info3.ok) {
    return info3;
  }

  const info4 = parseTypeIV(barCodeInfo);
  if (info4.ok) {
    return info4;
  }

  const infoBulk = parseBulk(barCodeInfo);
  return infoBulk;
}

export function packBarCode(decodedText) {
  return {
    ...newBarCodeInfo(decodedText),
    type: 'barcode',
    sCode: decodedText.replace(/\*/g, ''),
    ok: true,
  };
}

// TYPE I
//
// GTIN: (01) 14 digits
// EXP: (17) 6 digits
// LOT: (10) 5 to 7
// SER: (21) ...
function parseTypeI(info) {
  const _info = { ...info, type: 'type1' };

  // split the scanned code with information separator

  const data = _info.sCode
    .replace(/\*/g, '')
    // eslint-disable-next-line no-control-regex
    .split(/\x1D/g)
    .filter((s) => s.length > 0);
  if (data.length === 1) {
    const regex = /^01(\d{14})17(\d{6})10(.+)21(.{4,5})$/;
    if (regex.test(data[0])) {
      const [, gtin, expDate, lotNumber, serialNumber] = data[0].match(regex);

      return {
        ..._info,
        gtin: gtin,
        expDate: +expDate,
        lotNumber: lotNumber,
        serialNumber,
        ok: true,
      };
    }

    return _info;
  }

  if (data.length === 2) {
    const regex = /^01(\d{14})17(\d{6})10(.+)$/;
    const regex2 = /^21(.+)$/;
    if (regex.test(data[0]) && regex2.test(data[1])) {
      const [, gtin, expDate, lotNumber] = data[0].match(regex);
      const [, serialNumber] = data[1].match(regex2);

      return {
        ..._info,
        gtin: gtin || '',
        expDate: +expDate || -1,
        lotNumber: lotNumber || '',
        serialNumber,
        ok: true,
      };
    }
  }

  return _info;
}

// Type II
//
// GTIN: (01) 14 digits
// EXP: (17) 6 digits
// Manufactured Date: (11) 6 digits
// Lot: (10) ...
function parseTypeII(info) {
  const _info = { ...info, type: 'type2' };

  // remove noise characters
  const str = _info.sCode.replace(/[^0-9a-zA-Z-]/g, '');
  const regex = /^01(\d{14})17(\d{6})11(\d{6})10(.+)$/;
  if (regex.test(str)) {
    const [, gtin, expDate, manufacturedDate, lotNumber] = str.match(regex);

    return {
      ..._info,
      gtin: gtin,
      expDate: +expDate,
      manufacturedDate: +manufacturedDate,
      lotNumber: lotNumber,
      ok: true,
    };
  }

  return info;
}

// Type III
//
// GTIN: (01) 14 digits
// Manufactured Date: (11) 6 digits
// EXP: (17) 6 digits
// Lot: (10) ...
function parseTypeIII(info) {
  const _info = { ...info, type: 'type3' };

  // remove noise characters
  const str = _info.sCode.replace(/[^0-9a-zA-Z-]/g, '');
  const regex = /^01(\d{14})11(\d{6})17(\d{6})10(.+)$/;
  if (regex.test(str)) {
    const [, gtin, manufacturedDate, expDate, lotNumber] = str.match(regex);

    return {
      ..._info,
      gtin: gtin,
      expDate: +expDate,
      manufacturedDate: +manufacturedDate,
      lotNumber: lotNumber,
      ok: true,
    };
  }

  return info;
}

// TYPE IV
//
// GTIN: (01) 14 digits
// EXP: (17) 6 digits
// LOT: (10) 5 to 7
function parseTypeIV(info) {
  const _info = { ...info, type: 'type4' };

  // remove noise characters
  const str = _info.sCode.replace(/[^0-9a-zA-Z-]/g, '');
  const regex = /^01(\d{14})17(\d{6})10(.+)$/;
  if (regex.test(str)) {
    const [, gtin, expDate, lotNumber] = str.match(regex);

    return {
      ..._info,
      gtin: gtin,
      expDate: +expDate,
      lotNumber: lotNumber,
      ok: true,
    };
  }

  return _info;
}

// BULK Type
//
// SKU: (240) xxx
// Lot: (10) ...
// EXP: (17) 6 digits
// Extra: (91) xxx
// Qty: (37) xxx

function parseBulk(info) {
  const _info = { ...info, type: 'bulk' };

  // remove noise characters
  // eslint-disable-next-line no-control-regex
  const data = _info.sCode.split(/\*|\x1D/g).filter((s) => !!s && s.length > 1);

  if (!Array.isArray(data) || data.length !== 5) {
    return info;
  }

  try {
    const [, sku] = data.shift().match(/^240(.+)$/);
    if (typeof sku === 'undefined') return info;
    _info.sku = sku;

    const [, lotNumber] = data.shift().match(/^10(.+)$/);
    if (typeof lotNumber === 'undefined') return info;
    _info.lotNumber = lotNumber;

    const [, expDate] = data.shift().match(/^17(\d{6})$/);
    if (typeof expDate === 'undefined') return info;
    _info.expDate = +expDate;

    const [, extra] = data.shift().match(/^91(.+)$/);
    if (typeof extra === 'undefined') return info;

    const [, qty] = data.shift().match(/^37(\d+)$/);
    if (typeof lotNumber === 'undefined') return info;
    _info.iQty = +(qty || 1);

    return { ..._info, gtin: `${sku} BULK`, ok: true };
  } catch (error) {
    return info;
  }
}
